module.exports = __webpack_public_path__ + "static/media/id.46af3977.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/id.svg
// module id = 2113
// module chunks = 0